import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const cnsPlugin = createPlugin({
  id: 'cns',
  routes: {
    root: rootRouteRef,
  },
});

export const CnsPage = cnsPlugin.provide(
  createRoutableExtension({
    name: 'CnsPage',
    component: () => import('./pages/CnsPage').then((m) => m.CnsPage),
    mountPoint: rootRouteRef,
  }),
);
